import { Spin, Typography } from 'antd';

import type { LoadingBoxType } from '@app/components/LoadingBox/types';
import '@app/components/LoadingBox/styles/LoadingBox.desktop.scss';

const { Text } = Typography;

export const LoadingBox: LoadingBoxType = ({ isLoading, title }) => (
  <div className="loading-box-container" data-visible={isLoading}>
    <div className="spinner-container">
      <Spin spinning={true} size="large" />
      {title && <Text>{title}</Text>}
    </div>
  </div>
);
